import { createSelector } from 'reselect';
import { getImageSrcFromMediaObject } from 'erpcore/components/ImageManager';

export const getImage = (state, iri) => state?.imageManager?.collection?.[iri];

export const getImageUrl = (state, iri, version = null, expectedType = null) => {
    let url = null;
    if (state?.imageManager?.collection?.[iri]) {
        url = getImageSrcFromMediaObject(
            state?.imageManager?.collection?.[iri],
            version,
            expectedType
        );
    }

    return url;
};

export const getImageCollection = state => state?.imageManager?.collection;

export const getImageFetching = state => state?.imageManager?.fetching;
export const getImageFetchingData = state => state?.imageManager?.fetchingData;
export const getImageFetchingDataItem = (state, iri) => state?.imageManager?.fetchingData?.[iri];
export const getImageCreating = state => state?.imageManager?.creating;
export const getImageDeleting = state => state?.imageManager?.deleting;
export const getImageUpdating = state => state?.imageManager?.updating;

export default createSelector([
    getImage,
    getImageUrl,
    getImageCollection,
    getImageFetching,
    getImageFetchingData,
    getImageFetchingDataItem,
    getImageCreating,
    getImageDeleting,
    getImageUpdating
]);
